angular.module('cfn').factory('autoSaveServiceFactory', [
  '$log',
  '$timeout',
  '$q',
  '$http',
  '$rootScope',
  function($log, $timeout, $q, $http, $rootScope) {
    var AutoSaveService = function(restUrl, saveResponseHandler) {
      restUrl = restUrl.replace(/\/+$/, '');
      var saveTimeoutTime = 5000,
        saveTimeout = null,
        clientState = null,
        serverState = null,
        currentSavePromise = null,
        service = this;

      function cancelSaveTimeout() {
        if (saveTimeout !== null) {
          $timeout.cancel(saveTimeout);
        }
      }

      function isSaveRequired() {
        return !!clientState && !angular.equals(clientState, serverState);
      }

      /**
       * Restore initial state
       */
      service.reset = function() {
        $log.debug('reset()');
        cancelSaveTimeout();
        clientState = serverState = null;
      };

      /**
       * Report the current server state that has just been received
       */
      service.updateServerModel = function(currentState) {
        $log.debug('updateServerModel()');
        cancelSaveTimeout();
        serverState = angular.copy(currentState);
      };

      /**
       * Reports that something has changed, triggers the auto save timer
       */
      service.updateClientModel = function(currentState) {
        cancelSaveTimeout();

        clientState = angular.copy(currentState);

        if (isSaveRequired()) {
          // Debounce save operations
          saveTimeout = $timeout(function() {
            service.flush();
          }, saveTimeoutTime);
        }
      };

      /**
       * Makes sure that pending saves are executed. Returns a promise that is resolved when
       * nothing is pending.
       *
       * @param currentState optional state, if newer that previously reported
       */
      service.flush = function(currentModel) {
        $log.debug('flush()');

        var saveInProgress = !!currentSavePromise;

        if (currentModel) {
          service.updateClientModel(currentModel);
        }

        cancelSaveTimeout();

        if ($rootScope.modalActive && false) {
          $log.warn('Cannot flush save while modal is open');
          // TODO: Legacy implementation enqueued a save here,
          // we could call onStateChange(clientState) to achieve this
        } else if (isSaveRequired() && !saveInProgress) {
          currentSavePromise = $q.defer();

          function save() {
            //remember what we send to the server, this might get changed in the mean time
            var toSaveModel = angular.copy(clientState);
            $log.debug('saving');

            $http.post(restUrl, toSaveModel).then(
              function(response) {
                var data = response.data;
                //we are sure the sent model is now on the server
                serverState = toSaveModel;

                //allow the caller to modify the received state
                saveResponseHandler(data, serverState).then(function() {
                  // Do we have to save again because data changed in the meantime?
                  if (isSaveRequired()) {
                    save();
                  } else {
                    $log.info('saved');
                    currentSavePromise.resolve();
                    currentSavePromise = null;
                  }
                });
              },
              function() {
                $log.warn('save failed');

                currentSavePromise.resolve();
                currentSavePromise = null;
              }
            );
          }

          app.startLoading();
          save();
          currentSavePromise.promise.then(function() {
            app.finishLoading();
          });
        }
        // promise that is resolved when everything has been flushed
        return currentSavePromise ? currentSavePromise.promise : $q.when();
      };
    };

    var factory = {
      getInstance: function(restUrl, saveResponseHandler) {
        return new AutoSaveService(restUrl, saveResponseHandler);
      }
    };

    return factory;
  }
]);
